import React from "react";
import PopoverButton from "../PopoverButton";
export const withPopoverText = (currentMessage, popoverText, customHelperIcon) => {
  if (!popoverText) return currentMessage;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(PopoverButton, {
    popoverText: popoverText,
    customHelperIcon: customHelperIcon
  }), currentMessage);
};